<div>
  <!-- checkClickInside busca la clase report-button para no cerrar el menú al abrirlo -->
  <button
      mhFilterTrigger
      class="report-button"
      type="button"
      [filterOpen]="isOpen"
      [filterIconOnly]="!label"
      [attr.aria-label]="label ? null : ('header.tooltips.download_report' | translate)"
      [mhTooltip]="label ? '' : ('header.tooltips.download_report' | translate)"
      width="tw-w-fit"
      position="above"
      (click)="isOpen = !isOpen"
      cdkOverlayOrigin
      #trigger="cdkOverlayOrigin"
      >
      <ng-container *ngIf="!waiting; else downloading">
        <i class="fal fa-arrow-to-bottom tw-text-neutral-500"></i>
        <span *ngIf="label" class="tw-hidden tw-whitespace-nowrap tw-text-neutral-500 md:tw-inline">
          {{ label | translate }}
        </span>
      </ng-container>
      <ng-template #downloading>
        <i class="fad fa-spinner-third fa-spin tw-text-neutral-500"></i>
      </ng-template>
  </button>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayOffsetY]="hasSingleOption ? -10 : 160"
  >
  <div class="tw-mt-5 tw-rounded-lg tw-bg-white tw-p-3 tw-shadow-1">
    <ul class="example-list">
      <li class="tw-py-2" *ngIf="activeDownload">
        <button type="button" class="tw-text-main-text hover:tw-text-main focus:tw-outline-0" (click)="getReport()">
          <i class="fal fa-download"></i> {{'reports.downloads.excel.download_report' | translate}}
        </button>
      </li>
      <li class="tw-py-2" *ngIf="activeEmail">
        <button class="tw-text-main-text hover:tw-text-main focus:tw-outline-0" (click)="getReport(true)" >
          <i class="fal fa-envelope"></i> {{'reports.downloads.excel.send_report' | translate}}
        </button>
      </li>
    </ul>
  </div>
</ng-template>

